import React from 'react';
import { SEO } from './SEO';
import '../styles/legal.css';

export const Legal: React.FC = () => {
  return (
    <>
      <SEO 
        title="Legal Disclaimer"
        description="Legal terms and conditions for using POE2 Skills AI. Information about warranties, liability, and third-party content."
        canonicalUrl="https://www.poe2skills-ai.com/legal"
        noindex={true}
      />
      <div className="legal-container">
        <h1>Legal Disclaimer</h1>
        
        <section>
          <h2>Unofficial Community Tool</h2>
          <p>AI PoE2 Skills Planner is an unofficial fan-made tool and is in no way affiliated with or endorsed by Grinding Gear Games, the creators of Path of Exile. All trademarks and registered trademarks related to Path of Exile are the property of Grinding Gear Games.</p>
        </section>

        <section>
          <h2>No Warranties</h2>
          <p>The content on this site is provided "as is" without any guarantees or warranties of any kind, either express or implied. We make no warranties or representations regarding the accuracy, reliability, or completeness of any information provided on this site.</p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>Under no circumstances shall AI PoE2 Skills Planner or its owners, operators, or contributors be liable for any damages arising from the use or inability to use this website. This includes, without limitation, incidental and consequential damages, lost profits, or damages resulting from lost data or business interruption.</p>
        </section>

        <section>
          <h2>Third-Party Links and Content</h2>
          <p>This website may contain links to third-party websites or services. The content are from poe2db.tw that is not owned by AI PoE2 Skills Planner. The data from these links is not verified by AI PoE2 Skills Planner. These links are provided for convenience, and AI PoE2 Skills Planner is not responsible for the content, privacy policies, or practices of any third-party websites.</p>
        </section>

        <section>
          <h2>Changes to the Legal Terms</h2>
          <p>We reserve the right to modify these legal terms at any time. Any changes will be posted on this page, and it is your responsibility to review these terms regularly to ensure you agree with the latest version.</p>
        </section>

        <section>
          <h2>Contact Information</h2>
          <p>If you have any questions or concerns about the legal terms of this site, please contact us at randy.as.a.freelancer@gmail.com.</p>
        </section>
      </div>
    </>
  );
}; 